"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_CONFIG = void 0;
var BUTTON_CONFIG = {
  'manageInfo': {
    type: '',
    icon: 'icon-manage-info'
  },
  'close': {
    type: '',
    icon: 'el-icon-close'
  },
  'closeCircle': {
    type: '',
    icon: 'el-icon-circle-close'
  },
  'success': {
    type: 'success',
    icon: 'el-icon-success'
  },
  'refresh': {
    type: 'success',
    icon: 'el-icon-refresh'
  },
  'rightRefresh': {
    type: 'success',
    icon: 'el-icon-refresh-right'
  },
  'leftRefresh': {
    type: 'success',
    icon: 'el-icon-refresh-left'
  },
  'data': {
    type: 'primary',
    icon: 'el-icon-s-data'
  },
  'barChart': {
    type: 'primary',
    icon: 'el-icon-s-data'
  },
  'table': {
    type: 'primary',
    icon: 'icon-table'
  },
  'lineChart': {
    type: 'primary',
    icon: 'icon-line-chart'
  },
  'sCheck': {
    type: 'primary',
    icon: 'el-icon-s-check'
  },
  'check': {
    type: 'primary',
    icon: 'el-icon-check'
  },
  'checkCircle': {
    type: 'primary',
    icon: 'el-icon-circle-check'
  },
  'add': {
    type: 'primary',
    icon: 'el-icon-plus'
  },
  'addCircle': {
    type: 'primary',
    icon: 'el-icon-circle-plus'
  },
  'addCircleOutline': {
    type: 'primary',
    icon: 'el-icon-circle-plus-outline'
  },
  'edit': {
    type: 'primary',
    icon: 'el-icon-edit'
  },
  'editOutline': {
    type: 'primary',
    icon: 'el-icon-edit-outline'
  },
  'search': {
    type: 'primary',
    icon: 'el-icon-search'
  },
  'warn': {
    type: 'warning',
    icon: 'el-icon-warning'
  },
  'warnOutline': {
    type: 'warning',
    icon: 'el-icon-warning-outline'
  },
  'remove': {
    type: 'danger',
    icon: 'el-icon-minus'
  },
  'removeCircle': {
    type: 'danger',
    icon: 'el-icon-remove'
  },
  'removeCircleOutline': {
    type: 'danger',
    icon: 'el-icon-remove-outline'
  },
  'delete': {
    type: 'danger',
    icon: 'el-icon-delete'
  },
  'deleteSolid': {
    type: 'danger',
    icon: 'el-icon-delete-solid'
  },
  'setting': {
    type: 'danger',
    icon: 'el-icon-s-tools'
  },
  'error': {
    type: 'danger',
    icon: 'el-icon-error'
  }
};
exports.BUTTON_CONFIG = BUTTON_CONFIG;